<template lang="pug">
.mt-6.primary--text
  .text-md.font-semibold.mb-2 {{ $t('match_column_labels_to_customers') }}
  .mb-4
    span.font-bold {{ data.total_column }} 
    span {{ $tc('columns_have_been_recognize', data.total_column) }}
  v-data-table(:headers="headers" :items="items" :items-per-page="items.length" hide-default-footer disable-sort :mobile-breakpoint="0")
    template(v-slot:no-data)
      div
    template(v-slot:header.checked)
      yc-checkbox(v-model="checkAll" @change="onCheckedAll")
    template(v-slot:item.checked="{ item }")
      yc-checkbox(v-model="item.checked" @change="onChecked(item)")
    template(v-slot:item.field="{ item }")
      .my-2
        v-select.text-sm.round-xl(v-model="item.field" :items="options" dense outlined hide-details="auto" :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', contentClass: 'select-menu' }" append-icon="$yzi-chevron-down")
  .text-right.mt-4
    v-btn.button-md(@click="finishMapping" color="primary" depressed :loading="isLoading" :disabled="!checkedCount") {{ $t('finish_mapping') }}

  .dialogs
    y-dialog(v-if="showMapAllDialog" v-model="showMapAllDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-lg {{ $t('please_map_all_column') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md(@click="showMapAllDialog = false" color="primary" depressed) {{ $t('continue_mapping') }}

    y-dialog(v-if="showConfirmMappingDialog" v-model="showConfirmMappingDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          .text-lg.font-medium.mb-4 {{ checkedCount }} {{ checkedCount > 1 ? 'columns' : 'column' }}  will be imported. Another {{ totalCount - checkedCount }} columns will not be imported
          .text-md {{ $t('are_you_sure_to_proceed') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          v-btn.button-md.neutral500--text(@click="showConfirmMappingDialog = false" depressed text) {{ $t('mapping_field_confirmation_no') }}
          v-btn.button-md.white--text(@click="submitData" color="danger500" depressed) {{ $t('mapping_field_confirmation_yes') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['data', 'inputFile', 'os'],
  data: () => ({
    checkAll: true,
    showMapAllDialog: false,
    showConfirmMappingDialog: false,
    isLoading: false,
    totalCount: 0,
    headers: [
      { text: '', value: 'checked'},
      { text: 'Column', value: 'column' },
      { text: 'Sample Data', value: 'sample' },
      { text: 'Field', value: 'field' },
    ],
    backgroundCheckingInterval: null,
    currentFormData: null,
    options: [
      { text: 'Name', value: 'NAME' },
      { text: 'Phone', value: 'PHONE' },
      { text: 'Email', value: 'EMAIL' },
      { text: 'NRIC / Passport', value: 'IC'},
    ],
    items: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    checkedCount () {
      return this.items.filter(item => item.checked).length
    }
  },
  watch: {
    data () {
      this.updateItems()
    }
  },
  created () {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.updateItems()
  },
  methods: {
    ...mapActions(['showMessage']),
    updateItems() {
      const fields = []
      if (this.data) {
        this.data.data?.forEach(item => {
          const info = {
            checked: true,
            column: item[0],
            sample: item[1],
            field: null,
          }
          fields.push(info)
        })
      }
      this.items = fields
    },
    onCheckedAll (value) {
      this.items.map(item => item.checked = value)
    },
    onChecked (item) {
      if (!item.checked) {
        item.field = null
        this.checkAll = false
      }
    },
    finishMapping () {
      let isFieldEmpty = false
      this.items.map(item => {
        if (item.checked && !item.field) {
          isFieldEmpty = true
        }
      })
      if (isFieldEmpty) {
        this.showMapAllDialog = true
        return
      }
      const ids = this.items.filter(i => i.field).map(item => `${item.field}`.toLowerCase())
      if (ids.length !== new Set(ids).size) {
        this.showMessage(['error', 'Map only one field to a column'])
        return
      }
      this.totalCount = this.items.length
      if (this.checkedCount !== this.totalCount) {
        this.showConfirmMappingDialog = true
      } else {
        this.submitData()
      }
    },
    submitData () {
      this.showConfirmMappingDialog = false
      this.currentFormData = null
      const formData = new FormData()
      formData.append('file', this.inputFile)
      formData.append('header_row_index', 0)
      const fields = []
      this.items.forEach((item, index) => {
        const mapperIndex = `mapper[${index}]`
        if (item.checked) {
          fields.push(item.field)
          formData.append(`${mapperIndex}`, `${item.field}`.toUpperCase())
        } else {
          formData.append(mapperIndex, '')
        }
      })
      if (!fields.includes('NAME')) {
        this.showMessage(['error', 'Name field is required'])
        return
      }
      if (!fields.includes('PHONE')) {
        this.showMessage(['error', 'Phone field is required'])
        return
      }
      if (this.os === 'clinic' && !fields.includes('IC')) {
        this.showMessage(['error', 'NRIC / Passport field is required'])
        return
      }
      this.isLoading = true
      this.currentFormData = formData
      this.$axios.post(`/reviews/${this.company.slug}/invites/validate_csv`, formData)
        .then(resp => {
          this.$emit('onMapping', this.currentFormData)
          this.$emit('onValidate', resp.data)
        })
        .catch(e => {
          if (e.response?.data?.non_field_errors?.length > 0) {
            this.showMessage(['error', e.response.data.non_field_errors[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_import_csv')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__icon {
  min-width: 22px;
  width: 22px;
}
</style>